import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { AsyncSelect } from '@atlaskit/select';
import { getDropDownMenuPosition } from '../common/commonDropDownMenuProps';
import { SelectErrorContainer } from '../common/questionWrappers';
import { EditUserPickerMessage, IntlEditUserPickerMessages } from './EditUserPickerMessages.intl';
import { messages } from './messages';
export const EditUserPicker = ({
  id,
  isMulti,
  value,
  loadOptions,
  onChange,
  isInvalid,
  isRequired
}) => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(SelectErrorContainer, {
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement(AsyncSelect, _extends({
    id: id,
    value: value,
    loadOptions: loadOptions,
    noOptionsMessage: input => {
      if (input !== null && input !== void 0 && input.inputValue) {
        // The user entered something and we couldn't find a match.
        return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions);
      }
      // The user hasn't started typing yet, or deleted what they had typed.
      return intl.formatMessage(IntlEditUserPickerMessages[EditUserPickerMessage.UserPickerStartTyping]);
    },
    cacheOptions: true,
    isMulti: isMulti,
    isClearable: true,
    loadingMessage: () => /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownLoading),
    defaultOptions: true,
    onChange: onChange,
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect),
    isRequired: fg('proforma_a11y_mandatory_fields') ? isRequired : undefined
  }, getDropDownMenuPosition())));
};